// extracted by mini-css-extract-plugin
export default {"imageContainer":"web-push-accept-modal-module--imageContainer--c7e29","buttonsContainer":"web-push-accept-modal-module--buttonsContainer--b744b"};